import { Box, Grid2 } from '@mui/material';
import CardLastEvent from 'pages/MonitoringPage/_components/CardLastEvent';
import { useContext, useEffect, useState } from 'react';
import { getStreamByEndpointAsync } from 'services/Events';
import { transformDateStringInDate } from 'utils/TransformUtils';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import SchoolIcon from '@mui/icons-material/School';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import CameraIcon from '@mui/icons-material/Camera';
import ShieldIcon from '@mui/icons-material/Shield';
import { IDefenseEventSimpleProps } from 'services/Defense/Events/types';
import { DEFENSE_EVENTS_ENDPOINT } from '../../../../services/Defense/Events';
import { AppContext } from 'context/AppContextProvider';
import { Permissions } from 'services/enums';
import { t } from 'i18next';

interface DashboardMonitoringPageProps {
  events: any[];
}

const DashboardMonitoringPage = ({ events }: DashboardMonitoringPageProps) => {
  const [eventsDefense, setEventsDefense] = useState<
    IDefenseEventSimpleProps[]
  >([]);
  const [lastEvent, setLastEvent] = useState();
  const [ivsEvents, setIvsEvents] = useState<any[]>([]);
  const [lprEvents, setLprEvents] = useState<any[]>([]);
  const [facialEvents, setFacialEvents] = useState<any[]>([]);
  const [responsibleEvents, setResponsibleEvents] = useState<any[]>([]);
  const [studentEvents, setStudentEvents] = useState<any[]>([]);
  const { isRouteAllowed } = useContext(AppContext);

  const hasStudentPermission = isRouteAllowed(Permissions.STUDENT);
  const hasResponsiblePermission = isRouteAllowed(Permissions.RESPONSIBLE);

  useEffect(() => {
    getStreamByEndpointAsync(
      DEFENSE_EVENTS_ENDPOINT + '/last',
      setEventsDefense,
    );
  }, []);

  useEffect(() => {
    if (events.length > 0) {
      const lprEvent = events.filter(
        (event) => event.discriminator === 'LprEventEntity',
      );
      const facEvent = events.filter(
        (event) => event.discriminator === 'FaceRecognitionEventEntity',
      );
      const resEvent = events.filter(
        (event) => event.discriminator === 'ResponsibleRecognitionEventEntity',
      );
      const stEvent = events.filter(
        (event) => event.discriminator === 'StudentRecognitionEventEntity',
      );
      const ivsEvent = events.filter(
        (event) => event.discriminator === 'IvsEventEntity',
      );

      setLprEvents(lprEvent);
      setFacialEvents(facEvent);
      setResponsibleEvents(resEvent);
      setStudentEvents(stEvent);
      setIvsEvents(ivsEvent);

      const allEvents = [
        ...ivsEvent,
        ...lprEvent,
        ...facEvent,
        ...stEvent,
        ...resEvent,
      ];
      const mostRecentEvent = allEvents.reduce(
        (latest, current) =>
          transformDateStringInDate(current.createdAt) >
          transformDateStringInDate(latest.createdAt)
            ? current
            : latest,
        allEvents[0] || {},
      );
      setLastEvent(mostRecentEvent);
    }
  }, [events]);

  return (
    <>
      <Grid2
        display={'grid'}
        sx={{
          width: '99%',
          height: '100%',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gridTemplateRows: 'repeat(2, 1fr)',
          gap: 1,
          '@media (max-width: 900px)': {
            gridTemplateColumns: 'repeat(2, 1fr)',
            gridTemplateRows: 'repeat(3, 1fr)',
          },
        }}
      >
        {ivsEvents[0] && (
          <Box sx={{ width: '100%', height: '100%' }}>
            <CardLastEvent
              title={t('IVS')}
              event={ivsEvents[0]}
              widthProps={'60%'}
              nameEvent={''}
              iconProp={<CameraIcon />}
            />
          </Box>
        )}
        <Box sx={{ width: '100%', height: '100%' }}>
          {lprEvents[0] && (
            <CardLastEvent
              title={t('LPR')}
              event={lprEvents[0]}
              widthProps={'60%'}
              nameEvent={''}
              iconProp={<DriveEtaIcon />}
            />
          )}
        </Box>
        <Box sx={{ width: '100%', height: '100%' }}>
          {facialEvents[0] && (
            <CardLastEvent
              title={t('Facial')}
              event={facialEvents[0]}
              widthProps={'60%'}
              nameEvent={''}
              iconProp={<EmojiEmotionsIcon />}
            />
          )}
        </Box>
        {hasStudentPermission && (
          <Box sx={{ width: '100%', height: '100%' }}>
            <CardLastEvent
              title={t('Responsible')}
              event={studentEvents[0]}
              widthProps={'60%'}
              nameEvent={''}
              iconProp={<SchoolIcon />}
            />
          </Box>
        )}
        {hasResponsiblePermission && (
          <Box sx={{ width: '100%', height: '100%' }}>
            <CardLastEvent
              title={t('Student')}
              event={responsibleEvents[0]}
              widthProps={'60%'}
              nameEvent={''}
              iconProp={<FamilyRestroomIcon />}
            />
          </Box>
        )}
        <Box sx={{ width: '100%', height: '100%' }}>
          {eventsDefense[0] && (
            <CardLastEvent
              title={t('defense')}
              event={eventsDefense[0]}
              widthProps={'60%'}
              nameEvent={''}
              iconProp={<ShieldIcon />}
            />
          )}
        </Box>
      </Grid2>
    </>
  );
};

export default DashboardMonitoringPage;
